import styled from "styled-components";
import { ButtonStyleProps } from "./MyLocation.interface";

export const Container = styled.div`
  position: fixed;
  bottom: 24px;
  right: 8px;
  z-index: 999;
  > span {
    position: absolute;
    bottom: 54px;
    right: 54px;
    background-color: white;
    padding: ${({ theme }) => theme.spacing * 4}px;
    border-radius: ${({ theme }) => theme.radius}px;
    box-shadow: ${({ theme }) => theme.boxShadow};
    width: 200px;
    z-index: 2000;
    text-align: left;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.gray[900]};
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}) {
    bottom: 72px;
  }
`;

export const Button = styled.button<ButtonStyleProps>`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.shades[0]};
  box-shadow: ${({ theme }) => theme.boxShadow};
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  > svg {
    width: 24px;
    height: 24px;
    > g, path {
      fill: ${({ theme, hasPermission }) => hasPermission ? theme.colors.primary[500] : theme.colors.gray[400]};
    }
  }
`;
